<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.ZohoSalesOrder') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template slot>
                        <b-button variant="primary" @click="$router.go(-1)">
                            <b-icon icon="arrow-left" class="icon-style"></b-icon>
                        </b-button>
                        <!-- <b-button variant="primary" @click="handleUserAction">
                            <b-icon icon="person-plus" class="icon-style"></b-icon>
                        </b-button>
                        <b-button variant="primary"
                            @click="$router.push({ name: 'selectedInbox', params: { integrationId: $route.params.id } })">
                            <b-icon icon="envelope" class="icon-style"></b-icon>
                        </b-button> -->


                    </template>

                    <template #cell(actions)="{ item }">
                        <!-- Checkbox for selecting users -->
                        <input type="checkbox" :value="item.microsoft_user_id" v-model="selectedUsers" class="mr-2" />

                        <!-- Button with some margin-left for spacing -->
                        <!-- <b-button variant="light" class="ml-2"
                            @click="$router.push({ name: 'Inbox', params: { id: item.microsoft_user_id } })">
                            <b-icon variant="primary" icon="envelope" class="icon-style"></b-icon>
                        </b-button> -->
                    </template>


                    <!-- Display Response Payload -->
                    <template #cell(response_payload)="{ item }">
                        <div>
                            <div v-for="(value, key) in item.response_payload" :key="key"
                                class="d-flex justify-content-between align-items-center">
                                <span>
                                    <strong>{{ key }}</strong> :-{{ value }}
                                </span>
                            </div>
                        </div>
                    </template>


                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ formatDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";

const FILTER_FORM = {
    roles: null,
    statuses: null,
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'sales_order_id', label: self.$t('title.sales_order_id'), sortable: true },
    { key: 'sales_order_number', label: self.$t('title.sales_order_number'), sortable: true },
    { key: 'subject', label: self.$t('title.subject'), sortable: true },
    { key: 'account_name', label: self.$t('title.account_name'), sortable: true },
    { key: 'status', label: self.$t('title.status'), sortable: true },
    { key: 'total', label: self.$t('title.total'), sortable: true },
    { key: 'grand_total', label: self.$t('title.grand_total'), sortable: true },
    { key: 'sub_total', label: self.$t('title.sub_total'), sortable: true },
    { key: 'tax', label: self.$t('title.tax'), sortable: true },
    { key: 'discount', label: self.$t('title.discount'), sortable: true },
    { key: 'round_off_amount', label: self.$t('title.round_off_amount'), sortable: true },
    { key: 'adjustment', label: self.$t('title.adjustment'), sortable: true },
    { key: 'billing_street', label: self.$t('title.billing_address'), sortable: true },
    { key: 'shipping_street', label: self.$t('title.shipping_address'), sortable: true },
];


export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    mounted() {
        if(this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
        async handleUserAction() {
            this.isLoading = true; // optional loading state if needed
            const payload = {
                userIds: this.selectedUsers
            };

            try {
                const response = await request({
                    method: 'post',
                    url: '/admin/fetch-office-users-data',
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json' // Content type for JSON data
                    }
                });

                // Assuming the API returns an object with a property `status` to indicate success:
                if (response.status === true) {
                    // Trigger toast notification
                    this.$bvToast.toast('User stored successfully!', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                } else {
                    // Optionally handle a failed status if needed
                    this.$bvToast.toast('User storage failed.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                }
            } catch (error) {
                console.error("Error storing user IDs:", error);
                this.errorMessage = error.response ? error.response.data.message : error.message;
                // You might also want to show an error toast
                this.$bvToast.toast(this.errorMessage, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        }



    },
    computed: {
        listUrl() {
            return `admin/zoho/crm/sales-orders/${this.$route.params.id || ''}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
